<template>
  <div>
    <v-navigation-drawer app v-model="drawer" dark>
      <MobileMainMenu @close-drawer="drawer = false" />
    </v-navigation-drawer>
    <TopBar title="Admin3" @toggleDrawer="drawer = !drawer" />
    <router-view />
  </div>
</template>

<script>
import MobileMainMenu from './MainMenu.vue'
import TopBar from './TopBar.vue'

export default {
  components: { MobileMainMenu, TopBar },
  data() {
    return {
      drawer: false
    }
  }
}
</script>

<style></style>
